import { authorizedApiClient } from "Api";
import { isArray } from "lodash";
import { ErrorMessages } from './Helpers';

const prefix = "api/TimeflowUnifi";

const api = {
  submission: {
    submit: `${prefix}/submission/submit`
  },
  organisations: {
    getCompanyByOrbisId: `${prefix}/organisations/company/{orbisId}`,
  },
  configuration: {
    getTimeflowUnifiConfig: `${prefix}/configuration`,
  }
}

export const getMdmCompanyByOrbisId = async orbisId => {
  try {
    let request = `${api.organisations.getCompanyByOrbisId.replace("{orbisId}", orbisId)}`;
    let response = await authorizedApiClient.get(request);

    return {
      success: true,
      data: response.data
    };
  } catch (e) {
    return {
      success: false,
      errorMessage: ErrorMessages.getMdmCompanyByOrbisId
    };
  }
}

export const getTimeflowUnifiConfig = async () => {
  try {
    let request = `${api.configuration.getTimeflowUnifiConfig}`;
    let response = await authorizedApiClient.get(request);

    return {
      success: true,
      data: response.data
    };
  } catch (e) {
    return {
      success: false,
      errorMessage: ErrorMessages.getTimeflowUnifiConfig
    };
  }
}

export const submitPayee = async (request) => {
  let path = api.submission.submit;

  try {
    await authorizedApiClient.post(path, request);
    return { success: true };
  } catch (e) {
    const validationErrorMessage = getValidationErrorMessage(e);
    return {
      success: false,
      errorMessage: validationErrorMessage ? validationErrorMessage : ErrorMessages.submitPayee
    };
  }
}

const getValidationErrorMessage = errorResponse => {
  if (errorResponse.response?.status !== 400) return '';

  if (isArray(errorResponse.response.data)) {
    const messages = errorResponse.response.data?.map(error => error.errorMessage);
    return messages?.length ? messages.join('; ') : '';
  }

  return errorResponse.response.data?.title;
}